import React from 'react';

export const DocumentGridCardSkeleton: React.FC = () => {
    return (
        <div className="rounded-2xl p-[1px] bg-gradient-to-br from-gray-700/20 via-gray-600/20 to-gray-700/20">
            <div className="bg-[#0A0A0A] rounded-2xl p-5 flex flex-col h-full overflow-hidden">
                <div className="animate-pulse flex flex-col items-center">
                    {/* Icon Skeleton with Glow */}
                    <div className="relative w-16 h-16 mb-4">
                        <div className="absolute inset-0 bg-gray-700/20 blur-xl rounded-full" />
                        <div className="relative w-16 h-16 bg-gray-800/50 rounded-xl border border-gray-700/50 backdrop-blur-sm" />
                    </div>

                    {/* Title Lines */}
                    <div className="h-4 bg-gray-800 rounded w-3/4 mb-2" />
                    <div className="h-3 bg-gray-800/50 rounded w-1/2 mb-6" />

                    {/* Badge Chips Skeleton */}
                    <div className="flex gap-2 w-full justify-center mt-auto">
                        <div className="h-6 w-20 bg-gray-800/50 rounded-lg border border-gray-700/30" />
                        <div className="h-6 w-20 bg-gray-800/50 rounded-lg border border-gray-700/30" />
                        <div className="h-6 w-16 bg-gray-800/50 rounded-lg border border-gray-700/30" />
                    </div>
                </div>
            </div>
        </div>
    );
};
